"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var NavBar_1 = __importDefault(require("../navbar/NavBar"));
var SearchResultBar_1 = __importDefault(require("../searchResult/SearchResultBar"));
var NavBarForNews_1 = __importDefault(require("../navbar/NavBarForNews"));
var MarketplaceBar_1 = __importDefault(require("../navbar/MarketplaceBar"));
var UserSection_1 = __importDefault(require("../user/UserSection"));
var Notification_1 = __importDefault(require("../common/Notification"));
var EnvironmentIndicator_1 = __importDefault(require("../common/EnvironmentIndicator"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_i18next_1 = require("react-i18next");
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
var Header = function (props) {
    var viewer = props.viewer, suggestSearch = props.suggestSearch, disableNavBar = props.disableNavBar, disableMarketplaceBanner = props.disableMarketplaceBanner;
    var i18n = react_i18next_1.useTranslation().i18n;
    var onMessage = function (event) {
        if (event) {
            if (event.origin.includes('//id.')) {
                try {
                    var data = JSON.parse(event.data);
                    if (data.action === 'closeDialog' || data.action === 'close') {
                        if (props.refetch) {
                            props.refetch();
                        }
                    }
                }
                catch (e) { }
            }
        }
    };
    react_1.useEffect(function () {
        if (window.addEventListener) {
            window.addEventListener('message', onMessage, false);
        }
        else if (window['attachEvent']) {
            window.attachEvent('onmessage', onMessage, false);
        }
    }, []);
    var keyword = util_1.AppConfigService.getSearchKeyword();
    var style = {};
    // if (keyword) {
    //   style = {
    //     paddingBottom: '0px',
    //   }
    // }
    var showTopBar = util_1.AppConfigService.shouldShowMarketplaceTopBanner();
    var showSearchResultBar = [util_1.AppConfig.APERZA_SEARCH, util_1.AppConfig.APERZA_EC].includes(appConfig.serviceType) && keyword;
    return (react_1.default.createElement("div", { className: clsx_1.default('aw-container', {
            'aw-locale-en': i18n.language === 'en',
        }, {
            'aw-locale-ja': i18n.language !== 'en',
        }) },
        react_1.default.createElement(EnvironmentIndicator_1.default, null),
        react_1.default.createElement("div", null,
            (!disableMarketplaceBanner || showTopBar) && react_1.default.createElement(MarketplaceBar_1.default, null),
            react_1.default.createElement("div", { className: "aperza-header", style: style },
                react_1.default.createElement(UserSection_1.default, __assign({ viewer: viewer, suggestSearch: suggestSearch }, props)),
                !disableNavBar && !keyword && react_1.default.createElement(NavBar_1.default, __assign({ viewer: viewer }, props)),
                showSearchResultBar && react_1.default.createElement(SearchResultBar_1.default, __assign({ viewer: viewer }, props))),
            appConfig.serviceType == util_1.AppConfig.APERZA_NEWS && react_1.default.createElement(NavBarForNews_1.default, __assign({}, props)),
            react_1.default.createElement(Notification_1.default, null))));
};
Header.propTypes = {
    viewer: prop_types_1.default.any,
    suggestSearch: prop_types_1.default.any,
    disableSuggest: prop_types_1.default.bool,
    disableCartBadge: prop_types_1.default.bool,
    disableLogin: prop_types_1.default.bool,
    disableNavBar: prop_types_1.default.bool,
    disableNavCategory: prop_types_1.default.bool,
    disableNavCatalog: prop_types_1.default.bool,
    disableNavMarketplace: prop_types_1.default.bool,
    disableNavNews: prop_types_1.default.bool,
    disableNavExhibitions: prop_types_1.default.bool,
    disableNavManufacturers: prop_types_1.default.bool,
    disableNavShops: prop_types_1.default.bool,
    disableNavPromote: prop_types_1.default.bool,
    disableNavRegisterAccount: prop_types_1.default.bool,
    disableMarketplaceBanner: prop_types_1.default.bool,
    refetch: prop_types_1.default.func,
};
exports.default = Header;
